import { IContractsRepository } from 'modules/customer/domain/repositories';
import { Contract, IVectisContract } from 'modules/customer/infra/adapters';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

export default class VectisContractsRepository implements IContractsRepository {
  constructor(private httpProvider: IHTTPProvider) {}

  public findAll: IContractsRepository['findAll'] = async ({
    customerId,
    page,
    signed,
    size,
  }) => {
    const { totalPages, data } = await this.httpProvider.get<{
      totalPages: number;
      data: IVectisContract[];
    }>(`/area-cliente/financeiro/${customerId}/contratos`, {
      params: { page, size, assinados: signed },
    });

    return {
      totalPages,
      contracts: data.map(contract => new Contract(contract)),
    };
  };

  public findById: IContractsRepository['findById'] = async ({
    contractId,
    customerId,
  }) => {
    const contract = await this.httpProvider.get<IVectisContract>(
      `/area-cliente/financeiro/${customerId}/contrato`,
      { params: { idContrato: contractId } },
    );

    return new Contract(contract);
  };
}
